import { usePage } from "@inertiajs/react";
import type { ReactNode } from "react";

import { Toaster } from "@/components/ui/sonner";
import { useFlash } from "@/hooks/use-flash";

interface PublicLayoutProps {
  children: ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  const page = usePage<{ public_title?: string }>();
  const title = page.props.public_title ?? "Portal de Cotizaciones";
  // Use flash messages hook (now works because QuoteInvitationsController inherits from InertiaController)
  useFlash();

  return (
    <>
      {/* Simple public header */}
      <header className="bg-white border-b border-gray-200 px-4 py-3">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-lg font-medium text-gray-900">
            {title}
          </h1>
        </div>
      </header>

      {/* Main content */}
      <main>{children}</main>

      {/* Flash messages toaster */}
      <Toaster richColors position="top-center" />
    </>
  );
}
